import ReducerRegistry from "seneca-common/utils/state/reducer-registry";

import { APP_STATE_PATH } from "./consts";
import appReducer from "./reducers";

const reducerRegistry = ReducerRegistry.getInstance();

reducerRegistry.initialise(APP_STATE_PATH, builder => {
  builder.register(APP_STATE_PATH, appReducer);
});

export {
  appVersionIsUpdating,
  dismissPrompts,
  newAppVersionIsAvailable,
  newAppVersionIsInstalling,
  newPWAConfigReceived,
  serviceWorkerActive,
  setLastSeenPrompt,
  setUpdateToastHidden,
  showWarning
} from "./actions/pwa";
export {
  appVersionIsUpdating as getAppVersionIsUpdating,
  getLastSeenPrompt,
  newAppVersionAvailable as getNewAppVersionAvailable,
  newAppVersionInstalling as getNewAppVersionInstalling,
  getPWAStateSlice as getPWAState,
  serviceWorkerActive as getServiceWorkerActive,
  shouldShowPrompt,
  shouldShowWarning
} from "./selectors";
